// WB-INK-001 — renders ONE stroke group (plus later eraser marks that touch it) to a cropped PNG.
import { drawPen, drawEraseSegment } from './WhiteboardCanvas';

const PAD = 12;
const MAX_EDGE = 1024;

export const renderGroupPng = (strokes, erases, box) => {
  const scale = Math.min(2, MAX_EDGE / (Math.max(box.w, box.h) + 2 * PAD));
  const w = Math.max(1, Math.ceil((box.w + 2 * PAD) * scale));
  const h = Math.max(1, Math.ceil((box.h + 2 * PAD) * scale));

  const ink = document.createElement('canvas');
  ink.width = w; ink.height = h;
  const ctx = ink.getContext('2d');
  ctx.setTransform(scale, 0, 0, scale, (-box.x + PAD) * scale, (-box.y + PAD) * scale);
  strokes.forEach((s) => drawPen(ctx, { ...s, color: '#000000' }));
  erases.forEach((e) => {
    const pts = e.points;
    for (let i = 0; i < pts.length; i += 1) drawEraseSegment(ctx, e.width, pts[Math.max(0, i - 1)], pts[i]);
  });

  const out = document.createElement('canvas');
  out.width = w; out.height = h;
  const octx = out.getContext('2d');
  octx.fillStyle = '#ffffff';
  octx.fillRect(0, 0, w, h);
  octx.drawImage(ink, 0, 0);
  return { base64: out.toDataURL('image/png').split(',')[1], width: w, height: h };
};
